import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedAdminRoute = () => {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("userData");

  useEffect(() => {
    console.log("ProtectedAdminRoute - Current path:", location.pathname);
    console.log("ProtectedAdminRoute - Is authenticated:", !!isAuthenticated);
  }, [location.pathname, isAuthenticated]);

  if (!isAuthenticated) {
    console.log("ProtectedAdminRoute - Redirecting to home page");
    // Redirect to home page if not authenticated
    return <Navigate to="/user-panel/signin" replace />;
  }

  console.log("ProtectedAdminRoute - Access granted");
  return <Outlet />;
};

export default ProtectedAdminRoute;
